import * as React from "react"

const Facebook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8.5 1.6a6.396 6.396 0 0 0-.957 12.721V9.696H5.96V8.014h1.583v-1.12c0-1.853.903-2.666 2.444-2.666.737 0 1.127.055 1.312.08v1.467h-1.05c-.655 0-.883.62-.883 1.32v.919h1.917l-.26 1.682H9.366v4.638A6.396 6.396 0 0 0 8.5 1.6Z" />{" "}
  </svg>
)

export default Facebook
